import { bookmarkPost, followUser, likePost } from "../../../services/CommonFunctions";
import { updatePost } from "../../../store/slices/PostSlice";
import { updateShort } from "../../../store/slices/ShortSlice";

export const handleLike = async (id: string, dispatch: any, fileType: string) => {
    try {
        const response = await likePost(id);
        if (response.success === true) {
            // Update the post with the complete response data
            if (fileType === 'image') {
                dispatch(updatePost(response.data));
            } else {
                dispatch(updateShort(response.data));
            }
        } else {
            console.log('error', response.message);
        }
    } catch (error) {
        console.log('error', error);
    }

}
export const handleBookmark = async (id: string, dispatch: any, fileType: string) => {
    try {
        const response = await bookmarkPost(id);
        console.log('Bookmark response:', response);
        if (response.status === true) {
            if (fileType === 'image') {
                dispatch(updatePost(response.data));
            } else {
                dispatch(updateShort(response.data));
            }
        } else {
            console.log('Bookmark error:', response.message);
        }
    } catch (error) {
        console.log('Bookmark error:', error);
    }
}

export const handleFollow = async (userId: string, postId: string, dispatch: any, fileType: string) => {
    try {
        const res = await followUser(userId);
        if (fileType === 'image') {
            console.log('res in handleFollow', 'image' ,res);
            dispatch(updatePost({
                _id: postId,
                isFollowing: res?.isFollowing,
            }));
        } else {
            console.log('res in handleFollow', 'video');
            dispatch(updateShort({
                _id: postId,
                isFollowing: res?.isFollowing,
            }));
        }
    } catch (error) {
        console.log('error', error);
    }
 
}

// Reusable handlePress function that uses the standardized functions
export const createHandlePress = (
    dispatch: any,
    fileType: string,
    setShareBottomModelOpen?: (open: boolean) => void,
    setSelectedPostId?: (id: string) => void
) => {
    return (type: string, value: boolean, id: string) => {
        switch (type) {
            case 'share':
                setShareBottomModelOpen?.(true);
                break;
            case 'comment':
                setShareBottomModelOpen?.(true);
                setSelectedPostId?.(id);
                break;
            case 'like':
                handleLike(id, dispatch, fileType);
                break;
            case 'bookmark':
                handleBookmark(id, dispatch, fileType);
                break;
            default:
                break;
        }
    };
};
